export default __webpack_public_path__ + "static/brand-video-c8db0edd759144b3910109e9f1c3d703.png";